import EnumClass, { build } from '../EnumClass';
import data, { LicensePartnerId, LicensePartnerData } from './data';
import * as Translations from './translations';

export class LicensePartner extends EnumClass<LicensePartnerId, LicensePartnerData> {
  public get getName() {
    return Translations.name[this.id];
  }
}

export const {
  list: LICENSE_PARTNERS,
  getById: getLicensePartnerById,
  marshaller: LicensePartnerMarshaller,
  codec: LicensePartnerCodec,
} = build<LicensePartnerId, LicensePartnerData, LicensePartner>('LicensePartnerEnum', data, LicensePartner);
